"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _NewsletterPhone = _interopRequireDefault(require("./NewsletterPhone"));

var _NewsletterText = _interopRequireDefault(require("./NewsletterText"));

// import NewsletterHeureka from './NewsletterHeureka';
// import NewsletterSubscribe from './NewsletterSubscribe';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      width: '100%',
      backgroundColor: 'rgba(200,200,200,0.12)',
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column'
    }),
    logo: {
      paddingBottom: theme.spacing(1)
    },
    subscribe: {
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(3)
    }
  };
}, {
  name: 'Newsletter'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_NewsletterText.default, null);

function Newsletter(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      MainLogo = _ref.MainLogo,
      phoneNumber = _ref.phoneNumber,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "MainLogo", "phoneNumber"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(MainLogo, {
    className: classes.logo
  }), _ref2, phoneNumber && /*#__PURE__*/_react.default.createElement(_NewsletterPhone.default, {
    phoneNumber: phoneNumber
  }));
}

process.env.NODE_ENV !== "production" ? Newsletter.propTypes = {
  classes: _propTypes.default.shape({
    logo: _propTypes.default.string,
    root: _propTypes.default.string,
    subscribe: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  MainLogo: _propTypes.default.elementType.isRequired,
  phoneNumber: _propTypes.default.elementType.isRequired
} : void 0;
Newsletter.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = Newsletter;
exports.default = _default;